module.exports = __webpack_public_path__ + "img/portada.cd64584d.png";